// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reviewNovikov[data-v-0242b316]{align-items:center;background:#f7f8fa;display:flex;flex-direction:column;margin-top:-12px;padding:16px 0 32px}.reviewNovikov__popap[data-v-0242b316]{align-items:center;background:red;border-radius:16px;display:flex;height:72px;justify-content:space-between;margin-top:16px;padding:0 16px;width:calc(100% - 36px)}.reviewNovikov__popap-text[data-v-0242b316]{color:#fff;font-size:16px;font-weight:400;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
